import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import "./EnterpriseSection.css";

export const CorporateIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/corporate-grey.svg"
      : "/Image/Hero/corporate.svg";

  return <img src={src} alt="corporate" width={size} height={size} />;
};

export const GradIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Courses-grey.svg"
      : "/Image/Hero/Courses.svg";

  return <img src={src} alt="graduation" width={size} height={size} />;
};

export const StartupIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Startups-grey.svg"
      : "/Image/Hero/Startups.svg";

  return <img src={src} alt="startup" width={size} height={size} />;
};

export const TickIcon = () => {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        backgroundColor: "#2DC7FD",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      aria-hidden="true"
    >
      <img src="/Image/Hero/Tick2.svg" width="14px" height="14px" alt="" />
    </div>
  );
};

export default function EnterpriseSection() {
  const { t } = useTranslation();
  const history = useHistory();
  const [active, setActive] = useState("corporates");

  // 🔹 Tab order + direction logic (same idea as CareerSection)
  const tabOrder = {
    corporates: 0,
    universities: 1,
    startups: 2,
  };

  const [direction, setDirection] = useState("right");

  const handleTabChange = (nextKey) => {
    if (nextKey === active) return;

    const currentIndex = tabOrder[active];
    const nextIndex = tabOrder[nextKey];

    setDirection(nextIndex > currentIndex ? "right" : "left");
    setActive(nextKey);
  };

  const tabs = [
    {
      key: "corporates",
      label: t("home.enterprise.tabs.corporates"),
      title: t("home.enterprise.corporates.title"),
      desc: t("home.enterprise.corporates.desc"),
      benefits: [
        t("home.enterprise.corporates.benefits.0"),
        t("home.enterprise.corporates.benefits.1"),
        t("home.enterprise.corporates.benefits.2"),
        t("home.enterprise.corporates.benefits.3"),
      ],
    },
    {
      key: "universities",
      label: t("home.enterprise.tabs.universities"),
      title: t("home.enterprise.universities.title"),
      desc: t("home.enterprise.universities.desc"),
      benefits: [
        t("home.enterprise.universities.benefits.0"),
        t("home.enterprise.universities.benefits.1"),
        t("home.enterprise.universities.benefits.2"),
        t("home.enterprise.universities.benefits.3"),
      ],
    },
    {
      key: "startups",
      label: t("home.enterprise.tabs.startups"),
      title: t("home.enterprise.startups.title"),
      desc: t("home.enterprise.startups.desc"),
      benefits: [
        t("home.enterprise.startups.benefits.0"),
        t("home.enterprise.startups.benefits.1"),
        t("home.enterprise.startups.benefits.2"),
        t("home.enterprise.startups.benefits.3"),
      ],
    },
  ];

  const IconForKey = {
    corporates: CorporateIcon,
    universities: GradIcon,
    startups: StartupIcon,
  };

  const activeTab = tabs.find((tItem) => tItem.key === active) || tabs[0];

  const handleLearnMore = () => {
    history.push({
      pathname: "/signup",
      state: { detail: "LOCAL BUSINESS" },
    });
  };

  return (
    <section
      className="enterprise-section"
      role="region"
      aria-label={t("home.enterprise.ariaLabel", "Enterprise solutions")}
    >
      <div className="enterprise-inner" style={{ zIndex: 2 }}>
        <header className="enterprise-header">
          <h2 className="enterprise-title">
            {t("home.enterprise.header.titlePart1")}{" "}
            <span className="accent">{t("home.enterprise.header.accent")}</span>
          </h2>
          <p className="enterprise-sub">{t("home.enterprise.header.sub")}</p>
        </header>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <nav
            className="enterprise-tabs"
            role="tablist"
            aria-label={t(
              "home.enterprise.tabs.aria",
              "Enterprise audience"
            )}
          >
            {tabs.map((tItem, idx) => {
              const Icon = IconForKey[tItem.key];
              const isActive = active === tItem.key;
              return (
                <React.Fragment key={tItem.key}>
                  <button
                    role="tab"
                    aria-selected={isActive}
                    className={`ent-tab ${isActive ? "active" : ""}`}
                    onClick={() => handleTabChange(tItem.key)}
                  >
                    <span className="tab-ico-box">
                      <Icon size={22} color={isActive ? "white" : "black"} />
                    </span>
                    <span className="tab-label">{tItem.label}</span>
                  </button>

                  {idx < tabs.length - 1 && (
                    <div className="tab-sep" aria-hidden="true" />
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        </div>

        <div className="enterprise-main">
          <aside className="enterprise-info">
            {/* 🔹 Animated content panel like CareerSection */}
            <div
              key={active}
              className={`enterprise-info-panel ${
                direction === "right" ? "slide-in-right" : "slide-in-left"
              }`}
            >
              <h3>{activeTab.title}</h3>
              <p className="enterprise-info-desc">{activeTab.desc}</p>
              <ul className="enterprise-benefits">
                {activeTab.benefits.map((b, i) => (
                  <li key={i}>
                    <span className="tick-icon">
                      <TickIcon />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>

              <button className="btn-primary" onClick={handleLearnMore}>
                {t("home.enterprise.learnMore", "Learn More")}{" "}
                <img
                  src="/Image/Hero/learn more arrow.svg"
                  className="learn-arrow"
                  width="22px"
                  height="20px"
                  alt=""
                />
              </button>
            </div>
          </aside>

          <div className="enterprise-media">
            <div className="video-placeholder" aria-hidden="true">
              <div className="play-circle">
                <div className="play-triangle" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
